/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Daily_Picks_Description_HourInputs */

const en_daily_picks_description_hour = /** @type {(inputs: Daily_Picks_Description_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("en", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Refresh in ${i?.number} hour.`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Refresh in ${i?.number} hours.`);
	return /** @type {LocalizedString} */ (`Refresh in ${i?.number} hours.`)
	
};

const ar_daily_picks_description_hour = /** @type {(inputs: Daily_Picks_Description_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ar", i?.number, {});
	if (numberPlural == "zero") return /** @type {LocalizedString} */ (`التحديث خلال ${i?.number} ساعة.`);
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`التحديث خلال ${i?.number} ساعة.`);
	if (numberPlural == "two") return /** @type {LocalizedString} */ (`التحديث خلال ${i?.number} ساعتين.`);
	if (numberPlural == "few") return /** @type {LocalizedString} */ (`التحديث خلال ${i?.number} ساعات.`);
	if (numberPlural == "many") return /** @type {LocalizedString} */ (`التحديث خلال ${i?.number} ساعةً.`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`التحديث خلال ${i?.number} ساعة.`);
	return /** @type {LocalizedString} */ (`التحديث خلال ${i?.number} ساعة.`)
	
};

const de_daily_picks_description_hour = /** @type {(inputs: Daily_Picks_Description_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("de", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Aktualisierung in ${i?.number} Stunde.`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Aktualisierung in ${i?.number} Stunden.`);
	return /** @type {LocalizedString} */ (`Aktualisierung in ${i?.number} Stunden.`)
	
};

const es_daily_picks_description_hour = /** @type {(inputs: Daily_Picks_Description_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("es", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Se actualiza en ${i?.number} hora.`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Se actualiza en ${i?.number} horas.`);
	return /** @type {LocalizedString} */ (`Se actualiza en ${i?.number} horas.`)
	
};

const fr_daily_picks_description_hour = /** @type {(inputs: Daily_Picks_Description_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("fr", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Actualisation dans ${i?.number} heure.`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Actualisation dans ${i?.number} heures.`);
	return /** @type {LocalizedString} */ (`Actualisation dans ${i?.number} heures.`)
	
};

const it_daily_picks_description_hour = /** @type {(inputs: Daily_Picks_Description_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("it", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Aggiornamento tra ${i?.number} ora.`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Aggiornamento tra ${i?.number} ore.`);
	return /** @type {LocalizedString} */ (`Aggiornamento tra ${i?.number} ore.`)
	
};

const ja_daily_picks_description_hour = /** @type {(inputs: Daily_Picks_Description_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ja", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number}時間後に更新`);
	return /** @type {LocalizedString} */ (`${i?.number}時間後に更新`)
	
};

const ko_daily_picks_description_hour = /** @type {(inputs: Daily_Picks_Description_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ko", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number}시간 후 새로고침`);
	return /** @type {LocalizedString} */ (`${i?.number}시간 후 새로고침`)
	
};

const pt_br_daily_picks_description_hour = /** @type {(inputs: Daily_Picks_Description_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("pt_br", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Atualiza em ${i?.number} hora.`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Atualiza em ${i?.number} horas.`);
	return /** @type {LocalizedString} */ (`Atualiza em ${i?.number} horas.`)
	
};

const ru_daily_picks_description_hour = /** @type {(inputs: Daily_Picks_Description_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ru", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Обновление через ${i?.number} час.`);
	if (numberPlural == "few") return /** @type {LocalizedString} */ (`Обновление через ${i?.number} часа.`);
	if (numberPlural == "many") return /** @type {LocalizedString} */ (`Обновление через ${i?.number} часов.`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Обновление через ${i?.number} часа.`);
	return /** @type {LocalizedString} */ (`Обновление через ${i?.number} часа.`)
	
};

const th_daily_picks_description_hour = /** @type {(inputs: Daily_Picks_Description_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("th", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`รีเฟรชในอีก ${i?.number} ชั่วโมง`);
	return /** @type {LocalizedString} */ (`รีเฟรชในอีก ${i?.number} ชั่วโมง`)
	
};

const tr_daily_picks_description_hour = /** @type {(inputs: Daily_Picks_Description_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("tr", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} saat içinde yenilenir.`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} saat içinde yenilenir.`);
	return /** @type {LocalizedString} */ (`${i?.number} saat içinde yenilenir.`)
	
};

const zh_cn_daily_picks_description_hour = /** @type {(inputs: Daily_Picks_Description_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("zh_cn", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} 小时后刷新`);
	return /** @type {LocalizedString} */ (`${i?.number} 小时后刷新`)
	
};

const zh_tw_daily_picks_description_hour = /** @type {(inputs: Daily_Picks_Description_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("zh_tw", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} 小時後刷新`);
	return /** @type {LocalizedString} */ (`${i?.number} 小時後刷新`)
	
};

/**
* | numberPlural | output |
* | --- | --- |
* | "one" | "Refresh in {number} hour." |
* | "other" | "Refresh in {number} hours." |
* | * | "Refresh in {number} hours." |
*
* @param {Daily_Picks_Description_HourInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_picks_description_hour = /** @type {((inputs: Daily_Picks_Description_HourInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Picks_Description_HourInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_picks_description_hour(inputs)
	if (locale === "ar") return ar_daily_picks_description_hour(inputs)
	if (locale === "de") return de_daily_picks_description_hour(inputs)
	if (locale === "es") return es_daily_picks_description_hour(inputs)
	if (locale === "fr") return fr_daily_picks_description_hour(inputs)
	if (locale === "it") return it_daily_picks_description_hour(inputs)
	if (locale === "ja") return ja_daily_picks_description_hour(inputs)
	if (locale === "ko") return ko_daily_picks_description_hour(inputs)
	if (locale === "pt_br") return pt_br_daily_picks_description_hour(inputs)
	if (locale === "ru") return ru_daily_picks_description_hour(inputs)
	if (locale === "th") return th_daily_picks_description_hour(inputs)
	if (locale === "tr") return tr_daily_picks_description_hour(inputs)
	if (locale === "zh_cn") return zh_cn_daily_picks_description_hour(inputs)
	return zh_tw_daily_picks_description_hour(inputs)
});